// Must exactly match PENDING_REVIEW_MESSAGE in backend/carer_review.py —
// lets the UI distinguish "your carer account is under identity review"
// 403s from any other permission error, so it can show the review
// banner + Contact us link instead of a generic error toast.
export const CARER_REVIEW_PENDING_MESSAGE =
  "Your carer account is awaiting a routine identity review. We'll email you when the review is complete.";

export function isCarerReviewPending(err) {
  return (
    err?.response?.status === 403 &&
    err.response?.data?.detail === CARER_REVIEW_PENDING_MESSAGE
  );
}
